import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SystemItem } from 'fragments';
import { systemActions } from 'store';
import { CustomDelete } from 'components';
import { useModal } from 'utils';

export const System = () => {
    const dispatch = useDispatch();
    const { open } = useModal();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location?.pathname === '/practice-settings/zoom') {
            const params = new URLSearchParams(location.search);
            const code = params.get('code');
            const state = params.get('state');

            navigate('/practice-settings', { state: { activeTab: 'Integrations' } });
            dispatch(
                systemActions.connectZoomToTherapy({
                    code: code,
                    state: state,
                })
            );
            open(
                <CustomDelete
                    info={'Zoom connected successfully'}
                    text={' '}
                    innerText={'Ok'}
                    handleDel={() => dispatch(systemActions.getTelehealthStatus())}
                    okBtn={true}
                    body={
                        <div>
                            <p className="modal-header-sub">
                                Your Zoom account has been successfully connected to Therapy. You can now schedule and manage sessions using
                                Zoom.
                            </p>
                        </div>
                    }
                />
            );
        }
    }, [navigate]);

    useEffect(() => {
        if (location?.pathname === '/practice-settings/google-meet') {
            const params = new URLSearchParams(location.search);
            const code = params.get('code');
            const state = params.get('state');

            navigate('/practice-settings', { state: { activeTab: 'Integrations' } });
            dispatch(systemActions.connectGoogleMeetToTherapy({
                code: code,
                state: state,
            }));
            open(<CustomDelete
                info={'Google Meet connected successfully'}
                text={' '}
                innerText={'Ok'}
                handleDel={() => dispatch(systemActions.getTelehealthStatus())}
                okBtn={true}
                body={
                    <div>
                        <p className='modal-header-sub'>
                            Your Google Meet account has been successfully connected to TherapyLake.
                            You can now schedule and manage sessions using Google Meet.
                        </p>
                    </div>
                }
            />);
        }
    }, [navigate]);


    return <SystemItem />;
};
